import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import {getIdData } from "../../../lib/studentinfo"

export default function StudentTopMenu({slug, activeMenu}) {
  
  const [studentInfo, setStudentInfo] = useState(0);

  async function GetData() {
    const info = await getIdData(slug);
    setStudentInfo(info[0]?.class);
  }

useEffect(() => {
  GetData();
}, [])

  return (
    <div className="settings-widget">
    <div className="settings-inner-blk p-0">
      <div className="sell-course-head comman-space">
        <div className="sidebar-tag-labels">
  <ul className="list-unstyled">
    <li>
      <Link to={`/admin/admin-studentdetail/${slug}`}
      className={
        activeMenu === "Detail" ? "fw-bolder text-decoration-underline fs-5" : ""
      }
      >
        Info
      </Link>
    </li>
    {/* <li>
      <Link to={`/admin-student-profile/${slug}`}
      className={
        activeMenu === "Profile" ? "fw-bolder text-decoration-underline fs-5" : ""
      }
      >
        Student Profile
      </Link>
    </li> */}
    <li>
      <Link to={`/admin/admin-studentbooklist/${slug}`}
      className={
        activeMenu === "BookList" ? "fw-bolder text-decoration-underline fs-5" : ""
      }
      >Book List</Link>
    </li>
    {studentInfo === 12 ? 
    
    <li>
      <Link to={`/admin/admin-studentappcheck/${slug}`}
       className={
        activeMenu === "AppCheck" ? "fw-bolder text-decoration-underline fs-5" : ""
      }
      >App Check</Link>
    </li>
    : ""}
    <li>
      <Link to={`/admin/admin-studentpersonalquestion/${slug}`}
      className={
        activeMenu === "PersonalQuestions" ? "fw-bolder text-decoration-underline fs-5" : ""
      }
      >Personality</Link>
    </li>
    <li>
      <Link to={`/admin/admin-studentgoalgrades/${slug}`}
       className={
        activeMenu === "GoalGrades" ? "fw-bolder text-decoration-underline fs-5" : ""
      }
      >Goals</Link>
    </li>
    <li>
      <Link to={`/admin/admin-studentgradelist/${slug}`}
       className={
        activeMenu === "GradeList" ? "fw-bolder text-decoration-underline fs-5" : ""
      }
      >Grades</Link>
    </li>
    <li>
      <Link to={`/admin/admin-studentcollegeprofile/${slug}`}
       className={
        activeMenu === "CollegeProfile" ? "fw-bolder text-decoration-underline fs-5" : ""
      }
      >College Profile</Link>
    </li>
    <li>
      <Link to={`/admin/admin-studentaplicationprofile/${slug}`}
       className={
        activeMenu === "AplicationProfile" ? "fw-bolder text-decoration-underline fs-5" : ""
      }
      >Aplication Profile</Link>
    </li>
    <li>
      <Link to={`/admin/admin-studenttaskmanagement/${slug}`}
       className={
        activeMenu === "Task Management" ? "fw-bolder text-decoration-underline fs-5" : ""
      }
      >Agenda</Link>
    </li>
    <li>
      <Link to={`/admin/admin-parent/${slug}`}
       className={
        activeMenu === "Parent" ? "fw-bolder text-decoration-underline fs-5" : ""
      }
      >Parent</Link>
    </li>
  </ul>
</div>
      </div>
    </div>
  </div>
  )
}
